import { render, staticRenderFns } from "./work-order-change-process-detail.vue?vue&type=template&id=2fbde1dc&scoped=true"
import script from "./work-order-change-process-detail.vue?vue&type=script&lang=js"
export * from "./work-order-change-process-detail.vue?vue&type=script&lang=js"
import style0 from "./work-order-change-process-detail.vue?vue&type=style&index=0&id=2fbde1dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbde1dc",
  null
  
)

export default component.exports